import { useEffect, useState } from "react";
import { ChevronDown, Lock } from "lucide-react";
import { NavLink } from "react-router-dom";

function readCollapsed() {
  try { return JSON.parse(localStorage.getItem("nav_collapsed") || "{}"); } catch { return {}; }
}

function navTestId(to) {
  return `nav-${to === "/" ? "dashboard" : to.slice(1).replace(/\//g, "-")}`;
}

function NavModule({ module, isCollapsed, onToggle, lockedModules, onNavigate }) {
  const ModuleIcon = module.icon;
  const slug = module.label.toLowerCase().replace(/\s+/g, "-");
  return (
    <div className="nav-module" data-testid={`nav-module-${slug}`}>
      <button type="button" className="nav-section-label nav-module-header" onClick={() => onToggle(module.label)} aria-expanded={!isCollapsed} data-testid={`nav-module-toggle-${slug}`}>
        <span className="nav-module-title"><ModuleIcon size={14} /> {module.label}</span>
        <ChevronDown size={14} className={`nav-module-chevron${isCollapsed ? " collapsed" : ""}`} />
      </button>
      {!isCollapsed && module.items.map(({ to, label, icon: Icon, module: itemModule }) => (
        itemModule && lockedModules.includes(itemModule) ? (
          <NavLink key={to} to="/piano" className="nav-link is-locked" title="Non incluso nel piano attivo" onClick={onNavigate} data-testid={`${navTestId(to)}-locked`}>
            <Lock size={17} />
            {label}
          </NavLink>
        ) : (
          <NavLink key={to} to={to} end={to === "/"} className="nav-link" onClick={onNavigate} data-testid={navTestId(to)}>
            <Icon size={19} weight="bold" />
            {label}
          </NavLink>
        )
      ))}
    </div>
  );
}

export function SidebarNav({ modules, lockedModules = [], mobileOpen = false, onNavigate }) {
  const [collapsed, setCollapsed] = useState(readCollapsed);
  const labels = modules.map((module) => module.label).join("|");
  const toggleModule = (label) => setCollapsed((previous) => {
    const next = { ...previous, [label]: !previous[label] };
    localStorage.setItem("nav_collapsed", JSON.stringify(next));
    return next;
  });

  useEffect(() => {
    // sul telefono il menu si apre sempre con tutti i moduli chiusi
    if (mobileOpen) setCollapsed(Object.fromEntries(labels.split("|").map((label) => [label, true])));
  }, [mobileOpen, labels]);

  return (
    <nav className="nav-list" data-testid="main-navigation">
      {modules.map((module) => (
        <NavModule key={module.label} module={module} isCollapsed={Boolean(collapsed[module.label])} onToggle={toggleModule} lockedModules={lockedModules} onNavigate={onNavigate} />
      ))}
    </nav>
  );
}
